import Image1 from "../image/teretana/image1.webp";
import Image2 from "../image/teretana/image2.webp";
import Image3 from "../image/teretana/image3.webp";

export const TeretanaData = [
  {
    id: 1,
    image: Image1,
    alt: "Image teretana 1",
  },
  {
    id: 2,
    image: Image2,
    alt: "Image teretana 2",
  },
  {
    id: 3,
    image: Image3,
    alt: "Image teretana 3",
  },
];
